var getAlphabet = function () {
    var letters = [];
    for (var i = 97; i <= 122; ++i) {
        var letter = String.fromCharCode(i);
        letters.push(letter);
    }
    letters.push('#');
    return letters;
};
var groupBrandsAlphabetically = function (brands) {
    var groups = {};
    brands.forEach(function (brand) {
        var firstChar = brand.name[0].normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
        var group = isNaN(parseInt(firstChar)) ? firstChar : '#';
        if (groups[group]) {
            groups[group].push(brand);
            return;
        }
        groups[group] = [brand];
    });
    return groups;
};
export { getAlphabet, groupBrandsAlphabetically };
